module.exports = __webpack_public_path__ + "static/media/NEWS_hex2.f3ca2a1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/NEWS_hex2.png
// module id = 179
// module chunks = 0